export const vehiclesExportConfig = {
  entityName: 'Vehicles',
  filename: 'vehicles',
  sheetName: 'Vehicles',
  companyFields: [
    { field: 'Owner', strategy: 'customerIdString' },
  ],
  columns: [
    { header: 'Reference', getValue: row => row.Reference },
    { header: 'Owner', getValue: row => row.Owner },
    { header: 'Type', getValue: row => row.Type },
    { header: 'Category', getValue: row => row.Category },
    { header: 'Brand', getValue: row => row.Brand },
    { header: 'Model', getValue: row => row.Model },
    { header: 'Number Plate', getValue: row => row.NumberPlate },
    { header: 'Country', getValue: row => row.NumberPlateCountry },
  ],
  filters: [
    { label: 'Type', field: 'Type', type: 'multi-select' },
    { label: 'Category', field: 'Category', type: 'multi-select' },
    { label: 'Brand', field: 'Brand', type: 'multi-select' },
    { label: 'Owner', field: 'Owner', type: 'multi-select', companyOptions: { valueKey: 'customerIdString' } },
    { label: 'Country', field: 'NumberPlateCountry', type: 'multi-select' },
  ],
};
